import React, { useRef } from "react";
import moment from "moment";
import HourColumn from "./HourColumn";
import { SelectableGroup } from "react-selectable-fast";

export default function ShiftDay({ day, shifts, onEditPlan, onDeleteShift, dayHours }) {

  const dayRef = useRef();

  const dragFinished = (dates) => {
    // if (dates.length > 0) {
    //   let dayHours = dates.map(x => x.props);
    //   dayHours = dayHours.sort((a, b) => a.name.id - b.name.id);
    //   let start_date = moment.unix(dayHours[0].dayId).format("YYYY-MM-DD")
    //   let start_time = moment(`${start_date} ${dayHours[0].name.name}`);
    //   let dateEndTime = moment(`${start_date} ${dayHours[dayHours.length - 1].name.name}`).add(1, "hour");
    //   let newShift = {
    //     start_date: start_date,
    //     start_time: start_time.format("HH:mm"),
    //     end_time: dateEndTime.format("HH:mm") === "00:00" ? "23:59" : dateEndTime.format("HH:mm"),
    //     duration: dayHours.length,
    //     startGap: moment(dateEndTime).diff(start_time, "hours"),
    //     dateStamp: dayHours[0].dayId,
    //     isFirstDrag: true,
    //     createStamp: +moment()
    //   }
    //   if (dayRef.current) {
    //     dayRef.current.clearSelection();
    //   }
      // onShiftCreated(newShift);
    // }
  }

  return (
    <div className="dayContainer" key={day.id}>
      <div className="dayHeadingContainer">
        <div className="dayHeading">
          <div className="centered font-weight-bold">
            <div className="text-center">{day.day}</div>
            <div className="text-center">{day.name}</div>
          </div>
        </div>
      </div>
      <div className="dayTimeContainer" style={{ overflowX: "clip" }}>
        {dayHours ? (
          <SelectableGroup
            className="main"
            disabled={true}
            tolerance={20}
            allowClickWithoutSelected={false}
            globalMouse={false}
            resetOnStart={true}
            // scrollContainer="body"
            ref={dayRef}
            selectOnMouseMove={false}
            onSelectionFinish={dragFinished}
            deselectOnEsc
          >
            <div className="hours-holder">
              {dayHours.map((item) => (
                <HourColumn
                  onDeleteShift={onDeleteShift}
                  shifts={shifts.filter(shift => (shift.start_time === item.name || shift.visual_start_time === item.name) && shift.start_date === day.start_date)} key={item.id} name={item} dayId={day.id}
                  onEditPlan={onEditPlan} />
              ))}
            </div>
          </SelectableGroup>
        ) : ""}
      </div>
    </div>
  )
}